import React from "react";
import { PropTypes } from "prop-types";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

// The project pins chart.js@3 / react-chartjs-2@3 with no central registration,
// so register the pieces the Line chart needs here (registering is idempotent).
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title
);

const LineChart = ({ labels, appointments, sales }) => {
  const data = {
    labels: labels,
    datasets: [
      {
        label: "Appointments",
        data: appointments,
        borderColor: "#720b98",
        backgroundColor: "#720b98",
        yAxisID: "yAppointments",
        tension: 0.3,
      },
      {
        label: "Sales ($)",
        data: sales,
        borderColor: "#c2608e",
        backgroundColor: "#c2608e",
        yAxisID: "ySales",
        tension: 0.3,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: false,
      },
    },
    scales: {
      yAppointments: {
        type: "linear",
        position: "left",
        beginAtZero: true,
        title: {
          display: true,
          text: "Appointments",
        },
      },
      ySales: {
        type: "linear",
        position: "right",
        beginAtZero: true,
        grid: {
          drawOnChartArea: false,
        },
        title: {
          display: true,
          text: "Sales ($)",
        },
      },
    },
  };

  return <Line options={options} data={data} />;
};

LineChart.propTypes = {
  labels: PropTypes.array,
  appointments: PropTypes.array,
  sales: PropTypes.array,
};
export default LineChart;
